import styled from 'styled-components';

interface Props {}

const Tip = styled.div.attrs<Props>({
  className: 'text-sm text-black-gray',
})<Props>``;

export default Tip;
